import React from 'react';

import classes from './CreateNewQuizForm.module.css';

import FlexModal from '../../UI/FlexModal/FlexModal';
import IconButton from '../../UI/IconButton/IconButton';
import FormFields from '../../Forms/FormFields';
import Button from '../../UI/Button/Button';

import { IsObjectEmpty, IsStringEmpty, GetObjectClone } from '../../../utilities/CommonMethods';
import Input from '../../UI/Input/Input';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import Wrapper from '../../../hoc/Wrapper/Wrapper';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import { parseDateForInputField, parseTimeForInputField } from '../../../utilities/DateTimeUtils';

class CreateNewQuizForm extends React.Component {

    state = {
        createNewQuizForm: GetObjectClone(FormFields.createNewQuizForm),
        createNewQuizFormValid: false,
        errorMessage: '',
        showErrorMessage: false,
        showFormErrorMessage: false,
        formErrorMessage: '',
        showToolTip: false
    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.createNewQuizForm[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        const rules = formElement.validation;
        let value = formElement.value;
        if (!IsObjectEmpty(formElement.validation)) {
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                isValid = (value.length > 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }
        }
        if (!IsObjectEmpty(rules.date)) {
            if (rules.date.value && !IsStringEmpty(value) && formElement.label === 'Start Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // Start Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'Start date can not be empty';
                }

                let currentDate = new Date();
                let selectedDate = new Date(value + ' 00:00');

                let currentDateString = currentDate.getDate() + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear();
                let selectedDateString = selectedDate.getDate() + '-' + selectedDate.getMonth() + '-' + selectedDate.getFullYear();

                if (!IsStringEmpty(selectedDate.getTime()) && IsObjectEmpty(this.props.data)) {
                    if ((selectedDate.getTime() < currentDate.getTime()) && (selectedDateString !== currentDateString)) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Previous dates can not be selected.';
                    }
                }
            } else if (formElement.label === 'End Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // End Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'End date can not be empty';
                }

                let currentDate = new Date();
                let selectedDate = new Date(value + ' 00:00');

                let currentDateString = currentDate.getDate() + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear();
                let selectedDateString = selectedDate.getDate() + '-' + selectedDate.getMonth() + '-' + selectedDate.getFullYear();

                if (!IsStringEmpty(selectedDate.getTime())) {
                    if ((selectedDate.getTime() < currentDate.getTime()) && (selectedDateString !== currentDateString)) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Previous dates can not be selected.';
                    }
                }
            }
        }

        if (!IsObjectEmpty(rules.startTime)) {
            if (rules.startTime.value && !IsStringEmpty(value)) {
                const startTimeValue = value;
                const startDateValue = this.state.createNewQuizForm['startDate'].value;
                const dueTimeValue = this.state.createNewQuizForm['dueTime'].value;
                const dueDateValue = this.state.createNewQuizForm['dueDate'].value;

                let parsedStartTime = '', parsedDueTime = '';
                if (!IsStringEmpty(startDateValue) && !IsStringEmpty(dueDateValue)) {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse(startDateValue + ' ' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse(dueDateValue + ' ' + dueTimeValue);
                } else {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse('01/01/2021' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse('01/01/2021' + dueTimeValue);
                }

                if (!IsStringEmpty(parsedStartTime) && !IsStringEmpty(parsedDueTime)) {
                    if (parsedDueTime < parsedStartTime) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Start Time can not be larger than End Time';
                        this.state.createNewQuizForm['dueTime'].errorMessage = '';
                    } else if (parsedDueTime > parsedStartTime) {
                        isValid = true && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : '';
                        this.state.createNewQuizForm['dueTime'].valid = true;
                    }

                }
            }
        }
        if (!IsObjectEmpty(rules.dueTime)) {
            if (rules.dueTime.value && !IsStringEmpty(value)) {

                const dueTimeValue = value;
                const dueDateValue = this.state.createNewQuizForm['dueDate'].value;
                const startTimeValue = this.state.createNewQuizForm['startTime'].value;
                const startDateValue = this.state.createNewQuizForm['startDate'].value;

                let parsedStartTime = '', parsedDueTime = '';
                if (!IsStringEmpty(startDateValue) && !IsStringEmpty(dueDateValue)) {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse(startDateValue + ' ' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse(dueDateValue + ' ' + dueTimeValue);
                } else {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse('01/01/2021' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse('01/01/2021' + dueTimeValue);
                }

                if (!IsStringEmpty(parsedStartTime) && !IsStringEmpty(parsedDueTime) && !IsStringEmpty(value) && !IsStringEmpty(startTimeValue)) {
                    if (parsedDueTime < parsedStartTime) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Due Time can not be smaller than Start Time';
                        this.state.createNewQuizForm['startTime'].errorMessage = '';
                    } else if (parsedDueTime > parsedStartTime) {
                        isValid = true && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : '';
                        this.state.createNewQuizForm['startTime'].valid = true;
                    }
                } else if (IsStringEmpty(parsedDueTime)) {
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'This is a required field';
                }
            }
        }

        if (!IsObjectEmpty(rules.isPercentage) && rules.isPercentage.value && !IsStringEmpty(value)) {
            if ((isNaN(parseInt(value, 10)) === false) && typeof (parseInt(value, 10)) === 'number') {
                isValid = parseInt(value, 10) > 0 && parseInt(value, 10) < 100;
                formElement.errorMessage = isValid ? '' : rules.isPercentage.errorMessage;
                formElement.valid = isValid;
            } else {
                isValid = parseInt(value, 10) > 0 && isValid;
                formElement.errorMessage = isValid ? '' : rules.isNumber.errorMessage;
                formElement.valid = isValid;
            }

        } else if (!IsObjectEmpty(rules.isNumber) && rules.isNumber.value && !IsStringEmpty(value)) {
            isValid = typeof (parseInt(value, 10)) === 'number' && parseInt(value, 10) > 0 && isValid;
            formElement.errorMessage = isValid ? '' : rules.isNumber.errorMessage;
            formElement.valid = isValid;
        }

        return (formElement);
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.createNewQuizForm };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };

        let inputValue = event.target.value;

        if (inputIdentifier === 'quizTitle' && updatedFormElement.remainingChar > 0) {
            updatedFormElement.remainingChar = this.checkRemainingCount(event.target.value, inputIdentifier);
            inputValue = event.target.value;
        } else if (inputIdentifier === 'quizTitle' && updatedFormElement.remainingChar <= 0) {
            inputValue = event.target.value.substring(0, updatedFormElement.totalChar)
        } else {
            inputValue = event.target.value;
        }

        updatedFormElement.value = inputValue;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.valid = updatedFormElement.valid
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }

            this.setState({ createNewQuizForm: updatedForm, createNewQuizFormValid: formIsValid });
        }
    }

    onCreateQuizButtonClick = () => {
        const updatedForm = { ...this.state.createNewQuizForm };
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let formErrorMessage = '';
        if (formIsValid) {
            const schedule_date = this.state.createNewQuizForm['startDate'].value,
                schedule_time = this.state.createNewQuizForm['startTime'].value,
                due_date = this.state.createNewQuizForm['dueDate'].value,
                due_time = this.state.createNewQuizForm['dueTime'].value;

            const startDate = new Date(schedule_date + ' ' + schedule_time);
            const dueDate = new Date(due_date + ' ' + due_time);

            if (startDate.toLocaleString() === dueDate.toLocaleString()) {
                // formErrorMessage = 'Start Time and Due Time can not be same';
                const dueTimeElement = updatedForm['dueTime'];
                dueTimeElement.valid = false;
                dueTimeElement.errorMessage = 'Due Time and Start Time can not be same';
                updatedForm['dueTime'] = dueTimeElement;
                formIsValid = false;
            } else {
                formErrorMessage = '';
                formIsValid = formIsValid && true;
            }
        }


        this.setState({ createNewQuizForm: updatedForm, createNewQuizFormValid: formIsValid, showFormErrorMessage: !IsStringEmpty(formErrorMessage), formErrorMessage: formErrorMessage });
        if (formIsValid) {

            let quizFormData = {
                "name": this.state.createNewQuizForm['quizTitle'].value,
                "passing_percentage": this.state.createNewQuizForm['passMark'].value,
                "schedule_date": this.state.createNewQuizForm['startDate'].value,
                "schedule_time": this.state.createNewQuizForm['startTime'].value,
                "due_date": this.state.createNewQuizForm['dueDate'].value,
                "due_time": this.state.createNewQuizForm['dueTime'].value,
                "timer": this.state.createNewQuizForm['timeLimit'].value,
            };

            // console.log('Final Object Data =>>>', quizFormData)

            if (this.props.forEdit === true) {
                this.props.editQuizDetails(this.props.data.id, quizFormData);
            } else {
                this.props.createNewQuiz(quizFormData);
            }

        }
    }

    setFormData = () => {
        let updatedForm = { ...this.state.createNewQuizForm };

        let quizData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (!IsObjectEmpty(quizData)) {

            let quizName = '', passMarks = '', startDate = '', startTime = '', dueDate = '', dueTime = '', timeLimit = '';

            quizName = !IsStringEmpty(quizData.title) ? quizData.title : '';
            passMarks = !IsStringEmpty(quizData.passingPercentage) ? quizData.passingPercentage : '';
            timeLimit = !IsStringEmpty(quizData.timeLimit) && quizData.timeLimit !== '-' ? quizData.timeLimit : '';
            startDate = !IsStringEmpty(quizData.startDate) ? parseDateForInputField(new Date(quizData.startDate)) : '';
            dueDate = !IsStringEmpty(quizData.dueDate) ? parseDateForInputField(new Date(quizData.dueDate)) : '';
            startTime = !IsStringEmpty(quizData.startTime) ? parseTimeForInputField(quizData.startTime) : '';
            dueTime = !IsStringEmpty(quizData.dueTime) ? parseTimeForInputField(quizData.dueTime) : '';

            updatedForm['quizTitle'].value = quizName;
            updatedForm['passMark'].value = passMarks;
            updatedForm['startDate'].value = startDate;
            updatedForm['startTime'].value = startTime;
            updatedForm['dueDate'].value = dueDate;
            updatedForm['dueTime'].value = dueTime;
            updatedForm['timeLimit'].value = timeLimit.toString();

            this.setState({ createNewQuizForm: updatedForm });
        } else if (this.props.forEdit === false && !IsStringEmpty(this.props.selectedDate)) {
            updatedForm['startDate'].value = this.props.selectedDate;
            this.setState({ createNewQuizForm: updatedForm });
        }
    }

    componentDidMount() {
        this.setFormData();
    }

    inputFieldQuiz = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.createNewQuizForm[key].elementType}
            elementConfig={this.state.createNewQuizForm[key].elementConfig}
            label={this.state.createNewQuizForm[key].label}
            value={this.state.createNewQuizForm[key].value}
            options={this.state.createNewQuizForm[key].options}
            changed={(event) => this.inputChangedHandler(event, key)}
            touched={this.state.createNewQuizForm[key].touched}
            afterText={this.state.createNewQuizForm[key].remainingChar}
            dropdownOpen={this.state.createNewQuizForm[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            required={!IsObjectEmpty(this.state.createNewQuizForm[key].validation) ? (!IsObjectEmpty(this.state.createNewQuizForm[key].validation.required) ? this.state.createNewQuizForm[key].validation.required.value : false) : false}
            showError={(!this.state.createNewQuizFormValid && !this.state.createNewQuizForm[key].valid) ? true : false}
            error={this.state.createNewQuizForm[key].errorMessage}
        // disableDates={true}
        // disableDateValue={{ minDate: minDate, maxDate: maxDate }}
        />
    }

    render() {
        return (
            <FlexModal visible={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.CreateQuizFormContainer}>
                    <div className={classes.CloseIcon}>
                        <IconButton
                            styleclass='NoBorder SmallIcon'
                            icon={closeIconBlack}
                            altText='Close Icon'
                            clicked={() => this.props.closePopup('')}
                        />
                    </div>
                    <h3 className={classes.PopupHeading}>
                        {this.props.forEdit === true ? 'Edit Quiz' : 'Create New Quiz'}
                    </h3>

                    {this.props.showLoader
                        ? <div className={classes.FormLoaderContainer}>
                            <ShowLoader isLoading={this.props.showLoader} transparentBg={true} />
                        </div>
                        : <Wrapper>
                            <div className={classes.FormInput}>
                                {this.inputFieldQuiz('quizTitle')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('startDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('startTime')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('dueDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('dueTime')}
                            </div>

                            {
                                this.state.showFormErrorMessage
                                    ? <p className={classes.ErrorText}>{this.state.formErrorMessage}</p> : null
                            }

                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                <p className={classes.InputHeading}>Pass Marks</p>
                                <div className={[classes.FormShortWidthInput, classes.AddMarginRight].join(' ')}>
                                    {this.inputFieldQuiz('passMark')} <span>% of total marks</span>
                                </div>
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                <p className={classes.InputHeading}>Time Limit</p>
                                <div className={[classes.FormShortWidthInput, classes.AddMarginRight].join(' ')}>
                                    {this.inputFieldQuiz('timeLimit')} <span>mins</span>
                                </div>
                            </div>


                            <div className={classes.ButtonContainer}>
                                <Button
                                    styleclass="NonMobileOnly"
                                    label={this.props.forEdit ? "UPDATE QUIZ" : "CREATE QUIZ"}
                                    clicked={this.onCreateQuizButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="16px 20px 20px 0px"
                                />
                                <Button
                                    styleclass="MobileOnly"
                                    label={this.props.forEdit ? "UPDATE QUIZ" : "CREATE QUIZ"}
                                    clicked={this.onCreateQuizButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="0px"
                                    padding="1em 2em"
                                    fontSize="0.625em"
                                />
                            </div>
                        </Wrapper>
                    }
                </div>
            </FlexModal>
        );
    }
}

export default CreateNewQuizForm;